const init_state = {
  prevRoute: "",
  index: 0,
};
const routeReducer = (state = init_state, action) => {
  if (action.type === "assign") {
    return {
      ...state,
      prevRoute: action.payload.prevRoute,
      index: action.payload.index,
    };
  }

  return state;
};

export default routeReducer;
